import { render, staticRenderFns } from "./expirationReminder.vue?vue&type=template&id=5bb059f6"
import script from "./expirationReminder.vue?vue&type=script&lang=js"
export * from "./expirationReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports